import { useEffect, useState, type ReactNode } from "react";
import { API_BASE } from "../api/base";
import { SiteConfigContext, defaultConfig, type SiteConfig } from "./SiteConfigContext";

export function SiteConfigProvider({ children }: { children: ReactNode }) {
  const [config, setConfig] = useState<SiteConfig>(defaultConfig);

  useEffect(() => {
    fetch(`${API_BASE}/api/v1/shop/site-config`)
      .then((r) => r.json())
      .then((data: SiteConfig) => {
        setConfig(data);
        // Apply CSS custom properties to :root
        const root = document.documentElement;
        root.style.setProperty("--color-primary", data.color_primary);
        root.style.setProperty("--color-dark", data.color_dark);
        root.style.setProperty("--color-accent", data.color_accent);
        root.style.setProperty("--color-muted", data.color_muted);
        root.style.setProperty("--color-light-bg", data.color_light_bg);
        root.style.setProperty("--color-body-bg", data.color_body_bg);
        root.style.setProperty("--font-heading", data.font_heading);
        root.style.setProperty("--font-body", data.font_body);
        // Semantic tokens derived from theme
        root.style.setProperty("--color-text", data.color_dark);
        root.style.setProperty("--color-surface", data.color_light_bg);
      })
      .catch(() => {});
  }, []);

  return (
    <SiteConfigContext.Provider value={config}>
      {children}
    </SiteConfigContext.Provider>
  );
}
